module.exports = __webpack_public_path__ + "static/matilda_wardrobe-6434945c5d840dd4d2f5ed09762a31b8.jpg";